module.exports = __webpack_public_path__ + "static/img/download-qr-code.075afaf8.png";